import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';
import ServicePartPanelHeader from './ServicePartPanelHeader';
import ServicePartSectionPanelContent from './ServicePartSectionPanelContent';

export default class ServicePartSectionPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = { valid: this.isOptional(), selectedParts: []};
    }

    isOptional() {
        return this.props.partsSection.min == 0;
    }

    hasNoMaximumLimit() {
        return this.props.partsSection.max == 0;
    }

    isMaximumLimitNotReached() {
        return this.props.partsSection.max > this.state.selectedParts.length;
    }

    isMinimumLimitReached() {
        return this.state.selectedParts.length >= this.props.partsSection.min;
    }

    acceptsOnlyOneValue() {
        return this.props.partsSection.max == 1;
    }

    isValid() {
        return (this.isOptional() || this.isMinimumLimitReached() )
    }

    handleSelectPart(partId, event) {
        let selectedParts = [];

        if (event.target.checked) {
            // Radio button OR A checkbox with a true value

            if (this.hasNoMaximumLimit() || (this.isMaximumLimitNotReached())) {
                selectedParts = this.state.selectedParts.concat(partId);
            } else if (this.acceptsOnlyOneValue()) {
                // The user can add only 1 element
                selectedParts = [partId];
            }

        } else {
            // An unchecked checkbox

            const indexElement = this.state.selectedParts.indexOf(partId);

            selectedParts = this.state.selectedParts.slice(0, indexElement)
                .concat(this.state.selectedParts.slice(indexElement + 1));
        }

        this.setState({selectedParts: selectedParts});
        this.props.onSelectedPartsChanged(this.props.id, selectedParts);
    }

    handlePanelClick() {
        this.props.handleSelect(this.props.expanded ? null : this.props.eventKey);
    }

    render() {
        const partsSection = this.props.partsSection;
        const header = <ServicePartPanelHeader max={partsSection.max}
                                               min={partsSection.min}
                                               name={partsSection.name}
                                               eventKey={this.props.eventKey}
                                               expanded={this.props.expanded}
                                               parts={partsSection.service_part_options}
                                               selectedPartIds={this.state.selectedParts}
                                               handleSelect={this.handlePanelClick.bind(this)}/>;

        return <Panel collapsible={true}
                      expanded={this.props.expanded}
                      header={header}>
            <ServicePartSectionPanelContent partsSection={partsSection}
                                            max={partsSection.max}
                                            min={partsSection.min}
                                            selectedParts={this.state.selectedParts}
                                            handleSelectPart={this.handleSelectPart.bind(this)}/>
        </Panel>
    }
}
